<div class="densityWrap">

	<div class="densityControl" role="group" aria-label="Карток у рядку">

		<nb-icon icon="grid-outline" pack="eva" class="densityIcon"></nb-icon>

		<button *ngFor="let option of options"
			nbButton
			size="small"
			class="densityOption"
			[status]="option === cols ? 'primary' : 'basic'"
			[appearance]="option === cols ? 'filled' : 'ghost'"
			[attr.aria-pressed]="option === cols"
			(click)="select(option)">{{option}}</button>

	</div>

</div>
